import http from '@/plugins/http'
const adminApi = process.env.VUE_APP_ADMIN_API;

// 首页
export const getIndexData = (params={}) => {
    const url = adminApi  + 'common/indexData'
    return http.fetchGet(url, params);
}
//我的车型测评
export const getReportIndexData = (params={}) => {
    const url = adminApi  + 'report/index'
    return http.fetchGet(url, params);
}
//我的车型评测 推荐车型
export const getRecommendCar = (params={}) => {
    const url = adminApi  + 'report/recommend'
    return http.fetchGet(url, params);
}
//排行榜
export const getRankData = (params={}) => {
    const url = adminApi  + 'report/rank'
    return http.fetchGet(url, params);
}
export const getRankNodeData = (params={}) => {
    const url = adminApi  + 'report/rankNode'
    return http.fetchGet(url, params);
}
// 车型综述
export const getCarSummaryData = (params={}) => {
    const url = adminApi  + 'report/car/detail'
    return http.fetchGet(url, params);
}
//指标得分(性能,功能,旅途)
export const getCarScore = (params={}) => {
    const url = adminApi  + 'report/car/node'
    return http.fetchPost(url, params);
}
//指标得分(创新)
export const getCarScoreInnovate = (params={}) => {
    const url = adminApi  + 'report/car/innovateNode'
    return http.fetchPost(url, params);
}
//获取节点测评详情
export const getTestDetail = (params={}) => {
    const url = adminApi  + 'report/car/nodeDetail'
    return http.fetchPost(url, params);
}
//获取创新指标详情
export const getInnovateDetail = (params={}) => {
    const url = adminApi  + 'report/car/innovateNodeDetail'
    return http.fetchPost(url, params);
}
//获取创新标杆分析
export const getInnovateLineDetail = (params={}) => {
    const url = adminApi  + 'report/car/innovateAnalysisData'
    return http.fetchPost(url, params);
}
//获取一级标杆分析
export const getNodeLineDetail = (params={}) => {
    const url = adminApi  + 'report/car/functionAnalysisData'
    return http.fetchPost(url, params);
}
//获取二级标杆分析
export const getNodeLineTwoDetail = (params={}) => {
    const url = adminApi  + 'report/car/functionAnalysisDetail'
    return http.fetchPost(url, params);
}
//获取二级标杆
//添加竞品车型
export const addCompareCar = (params={}) => {
    const url = adminApi  + 'report/user/addCompareCar'
    return http.fetchPost(url, params);
}
//删除竞品车型
export const delCompareCar = (params={}) => {
    const url = adminApi  + 'report/user/delCompareCar'
    return http.fetchPost(url, params);
}
//获取竞品车型列表
export const getCompareCarList = (params={}) => {
    const url = adminApi  + 'report/user/compareCarList'
    return http.fetchPost(url, params);
}
//更换首页的车型
export const changeUserCar = (params={}) => {
    const url = adminApi  + 'report/user/updatePersonalizationCar'
    return http.fetchPost(url, params);
}
//搜索叶子节点
export const searchNode = (params={}) => {
    const url = adminApi  + 'report/search/node'
    return http.fetchPost(url, params);
}

//核心场景分析页面 二级节点列表
export const getParentNodes = (params={}) => {
    const url = adminApi  + 'report/car/coreScene/tree'
    return http.fetchPost(url, params);
}
//核心场景分析页面 二级节点列表
export const getNodeVideos = (params={}) => {
    const url = adminApi  + 'report/car/coreScene/videos'
    return http.fetchPost(url, params);
}

//添加收藏车型
export const addCollect = (params={}) => {
    const url = adminApi  + 'report/user/addCollect'
    return http.fetchPost(url, params);
}
//删除收藏车型
export const delCollect = (params={}) => {
    const url = adminApi  + 'report/user/delCollect'
    return http.fetchPost(url, params);
}

// 智能搜索车型列表
export const getSearchModel = (params={}) => {
    const url = adminApi  + 'report/car/permissionInfo'
    return http.fetchPost(url, params);
}
// 智能搜索结果
// ?model_id=&keyword=
export const getSearchResoult = (params={}) => {
    const url = adminApi  + 'report/search/nodeCompare'
    return http.fetchPost(url, params);
}

// 搜索车型
export const getSearchCar = (params={}) => {
    const url = adminApi  + 'report/search/car'
    return http.fetchPost(url, params);
}
// 搜索车型-创新
export const getSearchResoultCx = (params={}) => {
    const url = adminApi  + 'report/search/innovateNodeCompare'
    return http.fetchPost(url, params);
}